import React from 'react';
import { reduxForm } from 'redux-form';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import { userSignUp, setAccountError } from '@app/actions/accountActions';

import {
  FirstName,
  LastName,
  PhoneNumber,
  Country,
  UserName,
  Email,
  ConfirmEmail,
  Password,
  ConfirmPassword,
  AcceptTerms,
  AllowNews,
  ShareEmail,
  Button,
  MainContainer,
  PersonalInfo,
  AccountInfo,
  ErrorMessage,
  Recaptcha,
} from '@app/components';
import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';

const PersonalInfoColors = {
  fieldColor: colors.INTERNATIONAL_ORANGE,
  textColor: colors.RUST,
};

const AccountInfoColors = {
  textColor: colors.BUTTERFLY_BUSH,
};

class SignUp extends React.Component {
  componentWillUnmount() {
    const { setAccountError } = this.props;
    setAccountError(null);
  }

  render() {
    const { userSignUp } = this.props;
    return <SignUpForm onSubmit={userSignUp} />;
  }
}

SignUp.propTypes = {
  userSignUp: PropTypes.func.isRequired,
  setAccountError: PropTypes.func.isRequired,
};

let SignUpForm = ({
  handleSubmit, submitting, error, promoCode, history,
}) => (
  <MainContainer onSubmit={handleSubmit}>
    <PersonalInfo>
      <FieldsContainer>
        <SectionTitle>
          <FormattedMessage id="personalInformation.personalInfoHeader" />
        </SectionTitle>
        <FirstName {...PersonalInfoColors} />
        <LastName {...PersonalInfoColors} />
        <Country {...PersonalInfoColors} />
        <PhoneNumber {...PersonalInfoColors} />
      </FieldsContainer>
    </PersonalInfo>
    <AccountInfo>
      <FieldsContainer>
        <SectionTitle>
          <FormattedMessage id="personalInformation.accountInfoHeader" />
        </SectionTitle>
        <UserName {...AccountInfoColors} />
        <Email {...AccountInfoColors} />
        <ConfirmEmail {...AccountInfoColors} />
        <Password {...AccountInfoColors} withValidation />
        <ConfirmPassword {...AccountInfoColors} />
        <AcceptTerms />
        <AllowNews />
        <ShareEmail />
        <Recaptcha />
        {
          error && (
            <ErrorMessage>
              <FormattedMessage id={`signUp.errors.${get(error, 'code')}`} />
            </ErrorMessage>
          )
        }
        <ButtonsContainer>
          <Button
            labelId="subscribe.button.back"
            textColor={colors.ALICE_BLUE}
            backgroundColor={colors.INTERNATIONAL_ORANGE}
            disabled={submitting}
            onClick={() => (promoCode
              ? history.push(RouterConstants.SUBSCRIBE_PROMOTION)
              : history.push(RouterConstants.SUBSCRIBE))
            }
          />
          <Button
            type="submit"
            labelId="subscribe.button.next"
            textColor={colors.ALICE_BLUE}
            backgroundColor={colors.INTERNATIONAL_ORANGE}
            disabled={submitting}
            loading={submitting}
          />
        </ButtonsContainer>
      </FieldsContainer>
    </AccountInfo>
  </MainContainer>
);

SignUpForm.propTypes = {
  submitting: PropTypes.bool.isRequired, // This method is added by redux-form itself,
  handleSubmit: PropTypes.func.isRequired, // This method is added by redux-form itself
  history: PropTypes.oneOfType([PropTypes.object]).isRequired,
  promoCode: PropTypes.string,
  error: PropTypes.shape({
    code: PropTypes.number.isRequired,
    message: PropTypes.string,
  }),
};

SignUpForm.defaultProps = {
  promoCode: '',
  error: null,
};

const mapStateToProps = ({ account: { error }, subscribe: { promoCode } }) => ({
  error, promoCode,
});

SignUpForm = withRouter(connect(mapStateToProps)(SignUpForm));

SignUpForm = reduxForm({
  form: 'signUp',
})(SignUpForm);

export default connect(null, { userSignUp, setAccountError })(SignUp);

const SectionTitle = styled.h2`
  margin-left: -110px;
   @media (max-width: 820px) {
     margin-left: 0;
   }
`;

const FieldsContainer = styled.div`
  max-width: 520px;
  width: 100%;
  margin: auto;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-around;
  margin: 40px 0 20px;
`;
